<template>
    <div class="scroll-fade" ref="scrollElement">
        <slot></slot>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";

export default {
    name: "ScrollFade",
    props: {
        fadeTopClass: {
            type: String,
            default: "faded-top",
        },
        fadeBottomClass: {
            type: String,
            default: "faded",
        },
    },
    setup(props) {
        const scrollElement = ref(null);

        const handleScroll = () => {
            const el = scrollElement.value;

            if (!el) return;

            const scrollTop = el.scrollTop;
            const scrollHeight = el.scrollHeight;
            const clientHeight = el.clientHeight;
            const pos = scrollTop + clientHeight;

            if (scrollTop > 1) {
                el.classList.add(props.fadeTopClass);
            } else {
                el.classList.remove(props.fadeTopClass);
            }

            if (pos + 1 < scrollHeight) {
                el.classList.add(props.fadeBottomClass);
            } else {
                el.classList.remove(props.fadeBottomClass);
            }
        };

        onMounted(() => {
            if (scrollElement.value) {
                scrollElement.value.addEventListener("scroll", handleScroll);
            }
            handleScroll()
        });

        onUnmounted(() => {
            if (scrollElement.value) {
                scrollElement.value.removeEventListener("scroll", handleScroll);
            }
        });

        return {
            scrollElement,
        };
    },
};
</script>

<style scoped lang="scss">
.scroll-fade {
    overflow-y: auto;
    position: relative;
}

.no-fade{
    -webkit-mask-image: none;
}

.faded-top {
    -webkit-mask-image: linear-gradient(0deg, transparent, #fff 0 calc(100% - 15px), transparent);
}

.faded {
    -webkit-mask-image: linear-gradient(180deg, transparent, #fff 0 calc(100% - 15px), transparent);

    &.faded-top {
        -webkit-mask-image: linear-gradient(180deg, transparent, #fff 15px calc(100% - 15px), transparent);
    }
}
</style>